
import { defineComponent, watch, ref } from "vue";
import { AppData } from "@/store/app.data";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppFilterInput from "@/components/AppFilterInput.vue";
import AppFilterGakumonCheck from "@/components/AppFilterGakumonCheck.vue";
import AppFilterRitsuKubun from "@/components/AppFilterRitsuKubun.vue";
import AppFilterArea from "@/components/AppFilterArea.vue";
import AppFilterSDGs from "@/components/AppFilterSDGs.vue";
import AppSearch from "@/components/AppSearch.vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import VueElementLoading from "vue-element-loading";
import consts from "@/const/const";
const searchRepository = RepositoryFactory.getQuery("search");

// URLを取得
const getParameters = location.search;

function import_script(urls: string[]) {
  return Promise.all(
    urls.map(function (url: string) {
      return new Promise(function (resolve) {
        const script = document.createElement("script");
        script.src = url;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    })
  );
}
/**
 * Get the URL parameter value
 *
 * @param name {string} パラメータのキー文字列
 * @return url {url} 対象のURL文字列
 */
function getParam(name: string, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
/**
 * 半角カナを全角カナに変換。
 *
 * @auther ao-system
 */
function han2zen(str: string | null) {
  if (str == null) return null;
  const replaceDakuFm = [
    "ｳﾞ",
    "ｶﾞ",
    "ｷﾞ",
    "ｸﾞ",
    "ｹﾞ",
    "ｺﾞ",
    "ｻﾞ",
    "ｼﾞ",
    "ｽﾞ",
    "ｾﾞ",
    "ｿﾞ",
    "ﾀﾞ",
    "ﾁﾞ",
    "ﾂﾞ",
    "ﾃﾞ",
    "ﾄﾞ",
    "ﾊﾞ",
    "ﾋﾞ",
    "ﾌﾞ",
    "ﾍﾞ",
    "ﾎﾞ",
    "ﾊﾟ",
    "ﾋﾟ",
    "ﾌﾟ",
    "ﾍﾟ",
    "ﾎﾟ",
  ];
  const replaceDakuTo = [
    "ヴ",
    "ガ",
    "ギ",
    "グ",
    "ゲ",
    "ゴ",
    "ザ",
    "ジ",
    "ズ",
    "ゼ",
    "ゾ",
    "ダ",
    "ヂ",
    "ヅ",
    "デ",
    "ド",
    "バ",
    "ビ",
    "ブ",
    "ベ",
    "ボ",
    "パ",
    "ピ",
    "プ",
    "ペ",
    "ポ",
  ];
  for (var key in replaceDakuFm) {
    str = str.replace(new RegExp(replaceDakuFm[key], "g"), replaceDakuTo[key]);
  }

  const replaceFm = [
    "ｱ",
    "ｲ",
    "ｳ",
    "ｴ",
    "ｵ",
    "ｶ",
    "ｷ",
    "ｸ",
    "ｹ",
    "ｺ",
    "ｻ",
    "ｼ",
    "ｽ",
    "ｾ",
    "ｿ",
    "ﾀ",
    "ﾁ",
    "ﾂ",
    "ﾃ",
    "ﾄ",
    "ﾅ",
    "ﾆ",
    "ﾇ",
    "ﾈ",
    "ﾉ",
    "ﾊ",
    "ﾋ",
    "ﾌ",
    "ﾍ",
    "ﾎ",
    "ﾏ",
    "ﾐ",
    "ﾑ",
    "ﾒ",
    "ﾓ",
    "ﾔ",
    "ﾕ",
    "ﾖ",
    "ﾗ",
    "ﾘ",
    "ﾙ",
    "ﾚ",
    "ﾛ",
    "ﾜ",
    "ｦ",
    "ﾝ",
    "ｧ",
    "ｨ",
    "ｩ",
    "ｪ",
    "ｫ",
    "ｬ",
    "ｭ",
    "ｮ",
    "ｯ",
    "､",
    "｡",
    "ｰ",
    "｢",
    "｣",
    "ﾞ",
    "ﾟ",
  ];
  const replaceTo = [
    "ア",
    "イ",
    "ウ",
    "エ",
    "オ",
    "カ",
    "キ",
    "ク",
    "ケ",
    "コ",
    "サ",
    "シ",
    "ス",
    "セ",
    "ソ",
    "タ",
    "チ",
    "ツ",
    "テ",
    "ト",
    "ナ",
    "ニ",
    "ヌ",
    "ネ",
    "ノ",
    "ハ",
    "ヒ",
    "フ",
    "ヘ",
    "ホ",
    "マ",
    "ミ",
    "ム",
    "メ",
    "モ",
    "ヤ",
    "ユ",
    "ヨ",
    "ラ",
    "リ",
    "ル",
    "レ",
    "ロ",
    "ワ",
    "ヲ",
    "ン",
    "ァ",
    "ィ",
    "ゥ",
    "ェ",
    "ォ",
    "ャ",
    "ュ",
    "ョ",
    "ッ",
    "、",
    "。",
    "ー",
    "「",
    "」",
    "”",
    "",
  ];
  for (var key2 in replaceFm) {
    str = str.replace(new RegExp(replaceFm[key2], "g"), replaceTo[key2]);
  }
  return str;
}
// 全角英数記号全角変換
function abc123ToZEN(strVal: string | null): string | null {
  if (strVal == null) return null;
  var han = strVal.replace(/[A-Za-z0-9]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
  });
  return han;
}
/**
 * 規定のパラメータが一つもなければ false
 */
function checkParam() {
  if (getParam("Kw") != null && getParam("Kw") != "") return true;
  if (getParam("Dg") != null && getParam("Dg") != "") return true;
  if (getParam("Gb") != null && getParam("Gb") != "") return true;
  if (getParam("Kj") != null && getParam("Kj") != "") return true;
  if (getParam("New") != null && getParam("New") != "") return true;
  if (getParam("Gm") != null && getParam("Gm") != "") return true;
  if (getParam("Rt") != null && getParam("Rt") != "") return true;
  if (getParam("Ar") != null && getParam("Ar") != "") return true;
  if (getParam("Sd") != null && getParam("Sd") != "") return true;
  if (getParam("Mt") != null && getParam("Mt") != "") return true;
  if (getParam("Kwc") != null && getParam("Kwc") != "") return true;
  return false;
}
export default defineComponent({
  name: "Result",
  components: {
    AppHeader,
    AppFooter,
    AppFilterInput,
    AppFilterGakumonCheck,
    AppFilterRitsuKubun,
    AppFilterArea,
    AppFilterSDGs,
    AppSearch,
    VueElementLoading,
  },
  data() {
    return {
      posts: [],
      isFilterSearchOpen: false,
      isGakumonOpen: false,
      total: 0,
      gakumonData: AppData.gakumonData,
      ritsuKubunData: AppData.ritsuKubunData,
      areaData: AppData.areaData,
      SDGsData: AppData.SDGsData,
      Kw: "" as string | null,
      Dg: "" as string | null,
      Gb: "" as string | null,
      Kj: "" as string | null,
      New: "",
      searchMixValues: "" as string,
      SerKbn: "" as string | null,
      gakumonValues: [],
      ritsuKubunValues: [],
      areaValues: [],
      SDGsValues: [],
      consts: consts,
      loadingshow: false,
      isTmstart: false,
      genkoData: [],
      displist: [],
      searchKw: "" as string | null,
      relatedsearchwords: [],
      lectureParam: "" as string | null,
      finishCount: 0,
      usedsearchword: "" as string | null,
    };
  },
  created() {
    if (getParam("tmstart") == "1") this.isTmstart = true;
    this.initFetch();
    // this.$watch(
    //   // 2つのプロパティを含めた値を評価させる
    //   () => [this.Kw, this.Dg, this.Gb, this.Kj],
    //   // valueの型は上で返した配列になる
    //   (value:string[] | null) => {
    //     this.searchMixValues = value?.join(' ')
    //   }
    // );
    // よくわからなかったので書き換え
    if (getParam("Kw")) this.searchMixValues += "／" + getParam("Kw");
    if (getParam("Dg")) this.searchMixValues += "／" + getParam("Dg");
    if (getParam("Gb")) this.searchMixValues += "／" + getParam("Gb");
    if (getParam("Kj")) this.searchMixValues += "／" + getParam("Kj");
    if (this.searchMixValues.length > 0)
      this.searchMixValues = this.searchMixValues.slice(1);
  },
  computed: {
    // 検索数
    searchTotal(): number {
      return Object.keys(this.total).length;
    },
    // わけがわからなかったのでモード整理
    SearchMode(): string {
      var retMode = "Kw"; // 初期値関心ワード
      var modeCnt = 0;
      if (getParam("Kw") != null) {
        // 空白は指定ありnullはなし
        modeCnt++;
      }
      if (getParam("Dg") != null) {
        if (modeCnt == 0) retMode = "Dg"; // テキスト検索Dgだけのとき
        modeCnt++;
      }
      if (getParam("Gb") != null && modeCnt < 2) {
        if (modeCnt == 0) retMode = "Gb"; // テキスト検索Gbだけのとき
        modeCnt++;
      }
      if (getParam("Kj") != null && modeCnt < 2) {
        if (modeCnt == 0) retMode = "Kj"; // テキスト検索Kjだけのとき
        modeCnt++;
      }
      if (modeCnt >= 2) {
        retMode = "Multi"; // テキスト検索複数のとき
      }
      return retMode;
    },
    SetSerKbn(): string {
      var retParam = "";
      // 複合検索、学校種別、学校所在地、SDGsに指定があればn
      if (
        this.SearchMode == "Multi" ||
        getParam("Rt") != null ||
        getParam("Ar") != null ||
        getParam("Sd") != null ||
        getParam("New") != null
      ) {
        retParam = "n";
      } else if (this.SearchMode == "Dg" && getParam("Gm") == null) {
        // 大学名モードで学問分野なし
        retParam = "3";
      } else if (this.SearchMode == "Gb" && getParam("Gm") == null) {
        // 学部学科モードで学問分野なし
        retParam = "o";
      } else if (this.SearchMode == "Kj" && getParam("Gm") == null) {
        // 教授名モードで学問分野なし
        retParam = "4";
      } else if (
        getParam("Gm") != null &&
        this.SearchMode == "Kw" &&
        getParam("Kw") == null
      ) {
        // 学問分野ありでモードが初期値の場合
        retParam = "0";
      } else if (this.SearchMode == "Kw") {
        // ここまでこれば関心ワードのはず
        retParam = "2";
      }
      return retParam;
    },
  },
  methods: {
    async initFetch() {
      if (getParameters && checkParam()) {
        this.loadingshow = true;
        let genkodata: any;
        try {
          const { data } = await searchRepository.getQuery(getParameters);
          genkodata = data;
          // genkodata.searchkw = getParam("Kw");
          this.searchKw = getParam("Kw");
          this.genkoData = Object.assign({}, genkodata.genkoes);
          this.total = genkodata.genkoes;
          this.relatedsearchwords = genkodata.relatedsearchwords;
          let tvalparam = "";
          let tvalapi = "";
          if (this.searchKw) {
            tvalparam = this.searchKw.toUpperCase();
            tvalapi = genkodata.usedsearchword.toUpperCase();
          }
          if (
            abc123ToZEN(han2zen(tvalparam)) != abc123ToZEN(han2zen(tvalapi))
          ) {
            this.usedsearchword = genkodata.usedsearchword;
          }
        } catch (err) {
          this.loadingshow = false;
          alert("データの取得に失敗しました。");
          return false;
        }
        // this.posts = genkodata;
        // 動きが重いので一旦やめ
        this.searchRenderNext();
      }
      if (document.referrer.indexOf(location.pathname) > 0) {
        this.SerKbn = this.SetSerKbn;
      } else {
        if (getParam("SerKbn")) {
          this.SerKbn = getParam("SerKbn") as string;
        }
      }
      if (this.searchKw != null) {
        this.lectureParam = "&Kw=" + this.searchKw;
      }
      if (this.SerKbn != null) {
        this.lectureParam += "&SerKbn=" + this.SerKbn;
      }
      this.loadingshow = false;
    },
    searchRenderNext() {
      const self: any = this.displist;
      let vals: any = this.genkoData;
      let startCount = this.finishCount;

      var pushsetting = 30;
      // console.log(startCount + ' - ' +(startCount + pushsetting));
      var items = Object.keys(vals).slice(startCount, startCount + pushsetting);
      for (let len = items.length, i = 0; i < len; i++) {
        const item = items[i];
        self.push(vals[items[i]]);
      }
      this.finishCount += items.length;
    },
    onClickFilterSearchToggle() {
      this.isFilterSearchOpen = !this.isFilterSearchOpen;
    },
    onClickGakumonToggle() {
      this.isGakumonOpen = !this.isGakumonOpen;
    },
    onClickReset() {
      this.Kw = "";
      this.Dg = "";
      this.Gb = "";
      this.Kj = "";
      this.New = "";
      this.gakumonValues = [];
      this.ritsuKubunValues = [];
      this.areaValues = [];
      this.SDGsValues = [];
      [
        ...(document.querySelectorAll(
          ".p-result__filterSearch__inner input[type='checkbox']"
        ) as NodeListOf<HTMLInputElement>),
      ].forEach((element) => {
        element.checked = false;
      });
      document.querySelector<HTMLElement>("#js-checkedText")!.textContent = "";
      document.querySelector<HTMLElement>(
        "#js-checkedRitsuKubunText"
      )!.textContent = "";
      document.querySelector<HTMLElement>("#js-checkedAreaText")!.textContent =
        "";
      document.querySelector<HTMLElement>("#js-checkedSDGsValue")!.textContent =
        "";
      if (this.SearchMode == "Multi") {
        document
          .querySelector<HTMLElement>("#input_multidt")!
          .setAttribute("style", "display:none");
        document
          .querySelector<HTMLElement>("#input_multidd")!
          .setAttribute("style", "display:none");
        document
          .querySelector<HTMLElement>("#input_worddt")!
          .setAttribute("style", "display:flex");
        document
          .querySelector<HTMLElement>("#input_worddd")!
          .setAttribute("style", "display:unset");
      }
      sessionStorage.removeItem("search-params");
    },
    onClickSubmit() {
      var isExitsValue = false;

      // テキストボックス全てを取得
      const txts: NodeListOf<HTMLElement> =
        document.querySelectorAll("input[type='text']");
      for (let i = 0; i < txts.length; i++) {
        if ((txts[i] as HTMLInputElement).value != "") {
          isExitsValue = true;
          break;
        }
      }
      // チェックボックス全てを取得
      if (!isExitsValue) {
        const chks: NodeListOf<HTMLElement> = document.querySelectorAll(
          "input[type='checkbox']"
        );
        // 全てチェックボックスを選択した際のイベント取得
        for (let i = 0; i < chks.length; i++) {
          if ((chks[i] as HTMLInputElement).checked) {
            isExitsValue = true;
            break;
          }
        }
      }
      if (isExitsValue) {
        const jsPageSearch: HTMLFormElement = <HTMLFormElement>(
          document.getElementById("jsPageSearch")
        );
        // 空白条件省いてGET送信
        this.clean_query(jsPageSearch);
      } else {
        var modeName = "関心ワード";
        if (this.SearchMode == "Dg") {
          modeName = "大学名";
        } else if (this.SearchMode == "Gb") {
          modeName = "学部・学科名";
        } else if (this.SearchMode == "Kj") {
          modeName = "教授名";
        }
        alert(modeName + "を入力してからボタンをクリックしてください。");
      }
    },
    clean_query: function (frm: any) {
      let query = this.serialize(frm);
      location.href =
        frm.action +
        "?" +
        (function () {
          let arr: never[] = [];
          [].forEach.call((<string>query).split("&"), function (item) {
            if ((<string>item).split("=")[1]) {
              arr.push(item);
            }
          });
          let search = arr.join("&");
          let matchNum = 0;
          // 学問分野カンマ区切りやめる
          // let changeURI = search.replace(/Gm=/g, (match) => { if(matchNum-- == 0) return match; else return ','; })
          // const changeURIStrip = changeURI.replace(/&,/g, (match) => { return ',';})
          return search;
        })();
    },
    serialize: function (form: { nodeName: string; elements: string | any[] }) {
      let s: any[] = [];
      if (
        typeof form !== "object" &&
        (<HTMLFormElement>form).nodeName.toUpperCase() !== "FORM"
      ) {
        return s;
      }
      let length = form.elements.length;
      for (let i = 0; i < length; i++) {
        let field = form.elements[i];
        if (
          field.name &&
          !field.disabled &&
          field.type != "file" &&
          field.type != "reset" &&
          field.type != "submit" &&
          field.type != "button"
        ) {
          if (
            (field.type != "checkbox" && field.type != "radio") ||
            field.checked
          ) {
            s[s.length] =
              encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(field.value);
          }
        }
      }
      return s.join("&").replace(/%20/g, "+");
    },
    exactMatch() {
      // 最終的にKwモードでしか来ていません
      var setparam = "";
      var setpval = "";
      // とりあえずtemplateと同じ判定をする
      if (this.SearchMode == "Multi") {
        // 複数検索の意図は？
      } else if (this.SearchMode == "Dg") {
        if (this.Dg == null) return;
        setparam = "Dg";
        setpval = this.Dg;
      } else if (this.SearchMode == "Gb") {
        if (this.Gb == null) return;
        setparam = "Gb";
        setpval = this.Gb;
      } else if (this.SearchMode == "Kj") {
        if (this.Kj == null) return;
        setparam = "Kj";
        setpval = this.Kj;
      } else {
        // 関連検索で設定されるとthis.Kwに反映されない
        // const KwText: HTMLInputElement = <HTMLInputElement>document.getElementsByName("Kw")[0];
        const KwText: HTMLInputElement = <HTMLInputElement>(
          document.getElementById("js-RelatedWords")
        );
        this.Kw = KwText.value;
        setparam = "Kw";
        setpval = this.Kw;
        if (this.Kw == null || this.Kw == "") return;
      }
      // URLを取得
      var url = new URL(window.location.href);
      // URLSearchParamsオブジェクトを取得
      var params = url.searchParams;
      // var strurl = url.toString().replace(params.toString(), '').replace('?', '');
      // エンコード？かで上手く置換できていないのでURL文字生成
      var strurl = location.protocol + "//" + location.host + location.pathname;
      params.delete(setparam);
      params.delete("Mt");
      var KwMt = setparam + "=" + setpval + "&Mt=1";
      if (params.toString().length != 0) {
        KwMt = "&" + KwMt;
      }
      location.href = strurl + "?" + params.toString() + KwMt;
    },
    calculateScrollY() {
      const html = document.querySelector("html");
      const bodyHeight = document.body.clientHeight; // bodyの高さを取得
      const windowHeight = window.innerHeight; // windowの高さを取得
      const bottomPoint = bodyHeight - windowHeight;

      const currentPos = window.pageYOffset; // スクロール量を取得
      if (bottomPoint - 100 <= currentPos) {
        // スクロール量が最下部の位置を過ぎたかどうか
        // console.log('end');
        this.searchRenderNext();
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.calculateScrollY);
    import_script(["./js/lazysizes.min.js"]);
    import_script(["./js/ls.unveilhooks.min.js"]);
    import_script(["./js/gatag.js"]);

    // console.log(getParam("Kw"));
    if (getParam("Kw") || getParam("Kw") == "") {
      this.Kw = getParam("Kw");
    } // else
    if (getParam("Dg")) {
      this.Dg = getParam("Dg");
      const DgText: HTMLInputElement = <HTMLInputElement>(
        document.getElementsByName("Dg")[0]
      );
      DgText.value = this.Dg as string;
    } // else
    if (getParam("Gb")) {
      this.Gb = getParam("Gb");
      const GbText: HTMLInputElement = <HTMLInputElement>(
        document.getElementsByName("Dg")[0]
      );
      GbText.value = this.Gb as string;
    } // else
    if (getParam("Kj")) {
      this.Kj = getParam("Kj");
      const KjText: HTMLInputElement = <HTMLInputElement>(
        document.getElementsByName("Dg")[0]
      );
      KjText.value = this.Kj as string;
    }

    // パラメータより検索状態を設定(v-modelなどで引き継げそうだが上手くいかないので)
    // 学問分野
    if (getParam("Gm")) {
      // カンマ区切りやめる
      // const gbs = getParam("Gm")?.split(",");
      var url = new URL(location.href);
      let params = new URLSearchParams(url.search.slice(1));
      let vals = params.getAll("Gm");
      const setElms = document.getElementsByName("Gm");
      var tmpPId = "";
      var ccnt = 0;
      var selName = "";
      var tempSelName = "";
      setElms.forEach((elm) => {
        if ((vals as string[]).indexOf((elm as HTMLInputElement).value) > -1) {
          const pid: any = (elm as HTMLInputElement).getAttribute("pid");
          if (tmpPId != pid) {
            tmpPId = pid;
            selName += tempSelName;
            tempSelName = "";
            ccnt = 1;
          } else {
            ccnt++;
          }
          (elm as HTMLInputElement).checked = true;
          tempSelName += "、" + (elm as HTMLInputElement).getAttribute("lval");
          if (
            Number(document.getElementById(pid)?.getAttribute("ccnt")) == ccnt
          ) {
            // 全部チェックされていたら親チェック
            (document.getElementById(pid) as HTMLInputElement).checked = true;
            tempSelName =
              "、" +
              (document.getElementById(pid) as HTMLInputElement).getAttribute(
                "lval"
              );
          }
        }
      });
      selName += tempSelName;
      const checkedText: HTMLDivElement = <HTMLDivElement>(
        document.getElementById("js-checkedText")
      );
      checkedText.innerText = selName.slice(1);
    }
    // 設置区分
    var setName = "";
    setName = setSearchParamCheck("Rt");
    if (setName != "") {
      const checkedRitsuKubunText: HTMLDivElement = <HTMLDivElement>(
        document.getElementById("js-checkedRitsuKubunText")
      );
      checkedRitsuKubunText.innerText = setName;
    }
    // エリア
    setName = setSearchParamCheck("Ar");
    if (setName != "") {
      const checkedAreaText: HTMLDivElement = <HTMLDivElement>(
        document.getElementById("js-checkedAreaText")
      );
      checkedAreaText.innerText = setName;
    }
    // SDGs
    setName = setSearchParamCheck("Sd");
    if (setName != "") {
      const checkedSDGsValue: HTMLDivElement = <HTMLDivElement>(
        document.getElementById("js-checkedSDGsValue")
      );
      checkedSDGsValue.innerText = setName;
    }
    function setSearchParamCheck(key: string) {
      const setElms = document.getElementsByName(key);
      var url = new URL(location.href);
      let params = new URLSearchParams(url.search.slice(1));
      let vals = params.getAll(key);
      let selName = "";
      setElms.forEach((elm) => {
        if (vals.indexOf((elm as HTMLInputElement).value) > -1) {
          (elm as HTMLInputElement).checked = true;
          selName += "、" + (elm as HTMLInputElement).getAttribute("lval");
        }
      });
      return selName.slice(1);
    }

    /**
     * フォームリセット時にチェックされたラベルの文言・valueの値をリセット
     */
    const jsPageSearch: HTMLFormElement = <HTMLFormElement>(
      document.getElementById("jsPageSearch")
    );
    if (jsPageSearch) {
      jsPageSearch.onreset = () => {
        const checkedText: HTMLDivElement = <HTMLDivElement>(
          document.getElementById("js-checkedText")
        );
        checkedText.innerText = "";
        const checkedRitsuKubunText: HTMLDivElement = <HTMLDivElement>(
          document.getElementById("js-checkedRitsuKubunText")
        );
        checkedRitsuKubunText.innerText = "";
        const checkedAreaText: HTMLDivElement = <HTMLDivElement>(
          document.getElementById("js-checkedAreaText")
        );
        checkedAreaText.innerText = "";
        const checkedSDGsValue: HTMLDivElement = <HTMLDivElement>(
          document.getElementById("js-checkedSDGsValue")
        );
        checkedSDGsValue.innerText = "";
      };
    }
    /**
     * スマホ表示の時にフィルター検索をモーダルとして表示
     * #js-toggleContentのhtmlをモーダル内の.c-modalFilterSearch__contentに挿し込む
     */
    const modalOpenButton: HTMLButtonElement = <HTMLButtonElement>(
      document.getElementById("js-modal__opener")
    );
    const modalOpenScrollButton: HTMLButtonElement = <HTMLButtonElement>(
      document.getElementById("js-scrollFilter")
    );
    const modal__wrapper: HTMLDivElement = <HTMLDivElement>(
      document.querySelector(".c-modalFilterSearch__wrapper")
    );
    const modal__content: HTMLDivElement = <HTMLDivElement>(
      document.querySelector(".c-modalFilterSearch__content")
    );
    const addContent: HTMLElement = <HTMLElement>(
      document.getElementById("js-toggleContent")
    );

    function attachModalListeners(modalElm: HTMLDivElement) {
      modalElm
        .querySelector(".close_modal")
        ?.addEventListener("click", toggleModal);
    }
    function detachModalListeners(modalElm: HTMLDivElement) {
      modalElm
        .querySelector(".close_modal")
        ?.removeEventListener("click", toggleModal);
    }
    function toggleModal() {
      const currentState = modal__wrapper.style.display;
      modal__content.insertAdjacentElement("afterbegin", addContent);
      if (currentState === "none") {
        modal__wrapper.style.display = "block";
        attachModalListeners(modal__wrapper);
        document.body.classList.add("js-modalOpen");
      } else {
        modal__wrapper.style.display = "none";
        detachModalListeners(modal__wrapper);
        document.body.classList.remove("js-modalOpen");
      }
    }
    if (modalOpenButton) {
      modalOpenButton.addEventListener("click", toggleModal);
    }
    if (modalOpenScrollButton) {
      modalOpenScrollButton.addEventListener("click", toggleModal);
    }
    /**
     * #js-toggleGakumonCheckをクリックすると、#js-toggleGakumonCheckContentが開く
     * .js-accordionArrowをクリックすると、tdが開く
     */
    document.addEventListener("click", (e) => {
      if (e.target && (e.target as Element).id === "js-toggleGakumonCheck") {
        (<HTMLElement>e.target).classList.toggle("js-active");
        (<HTMLElement>(
          (<HTMLElement>e.target).parentNode
        )).nextElementSibling?.classList.toggle("js-open");
      }
      if (
        e.target &&
        (e.target as Element).classList.contains("js-accordionArrow")
      ) {
        (<HTMLElement>e.target).classList.toggle("js-active");
        (<HTMLElement>(
          (<HTMLElement>e.target).parentNode
        )).nextElementSibling?.classList.toggle("js-open");
      }
    });

    /*!
     * submitボタンのEnterキーを無効化
     */
    const form = document.querySelector("form");
    // フォームのkeydownイベントを設定
    if (form) {
      form.addEventListener("keydown", (e) => {
        if (e.keyCode === 13) {
          // エンターキーが押されたときの動作
          e.preventDefault();
        }
      });
    }

    // mounted終わり
  },
});
